export default __webpack_public_path__ + "67e34a97f8819de22f6dd5e8d7182cb0.png";